@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  background-color: var(--white);
  padding: @space-48 @space-24;
  border-radius: 0 0 8px 8px;
}

.icon-container {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  width: 80px;
  height: 80px;
}

.text-container {
  align-items: center;
  text-align: center;
}

.title {
  font-size: 16px;
  font-weight: 700;
  color: var(--grey-900);
  line-height: 24px;
}

.description {
  font-size: 14px;
  font-weight: 400;
  color: var(--grey-600);
  line-height: 20px;
}
